import React from 'react';
import Slider from './Slider';
import Cards from './Cards';

const Body = () => {
  return (
    <div className='body max-w-[100%]'>
      <Slider/>
      <Cards/>
    </div>
  )
}

export default Body